module.exports = __webpack_public_path__ + "static/img/start.e2af367.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Waving/start.jpg
// module id = gAwb
// module chunks = 1